
import { route } from 'quasar/wrappers'
import { createRouter, createMemoryHistory, createWebHistory, createWebHashHistory } from 'vue-router'

import { useAuth } from 'src/composables/auth';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

let routes = [{
	name: 'main',
	path: '/',
	component: () => import('layouts/MainLayout.vue'),
	children: [
		//Dashboard routes


//addresses routes
		{ path: '/addresses', name: 'addresseslist', component: () => import('pages/addresses/list.vue'), props: true },
		{ path: '/addresses/index/:fieldName?/:fieldValue?', component: () => import('pages/addresses/list.vue'), props: true },
		{ path: '/addresses/view/:id', name: 'addressesview', component: () => import('pages/addresses/view.vue'), props: true },
		{ path: '/addresses/add', name: 'addressesadd', component: () => import('pages/addresses/add.vue'), props: true },
		{ path: '/addresses/edit/:id', name: 'addressesedit', component: () => import('pages/addresses/edit.vue'), props: true },

//audits routes

//booklet_page routes
		{ path: '/booklet_page', name: 'booklet_pagelist', component: () => import('pages/booklet_page/list.vue'), props: true },
		{ path: '/booklet_page/index/:fieldName?/:fieldValue?', component: () => import('pages/booklet_page/list.vue'), props: true },

//booklet_status routes

//cars routes
		{ path: '/cars', name: 'carslist', component: () => import('pages/cars/list.vue'), props: true },
		{ path: '/cars/index/:fieldName?/:fieldValue?', component: () => import('pages/cars/list.vue'), props: true },
		{ path: '/cars/view/:id', name: 'carsview', component: () => import('pages/cars/view.vue'), props: true },
		{ path: '/cars/add', name: 'carsadd', component: () => import('pages/cars/add.vue'), props: true },
	    { path: '/cars/replace/:oldCarId/:oldRegister', name: 'carsreplace', component: () => import('pages/cars/replace.vue'), props: true },
		{ path: '/cars/editmanager/:id', name: 'carseditmanager', component: () => import('pages/cars/editmanager.vue'), props: true },
		{ path: '/cars/listfleet', name: 'carslistfleet', component: () => import('pages/cars/listfleet.vue'), props: true },

//carssources routes

//clients routes
		{ path: '/clients', name: 'clientslist', component: () => import('pages/clients/list.vue'), props: true },
		{ path: '/clients/index/:fieldName?/:fieldValue?', component: () => import('pages/clients/list.vue'), props: true },
		{ path: '/clients/view/:id', name: 'clientsview', component: () => import('pages/clients/view.vue'), props: true },

//config routes
		{ path: '/config', name: 'configlist', component: () => import('pages/config/list.vue'), props: true },
		{ path: '/config/index/:fieldName?/:fieldValue?', component: () => import('pages/config/list.vue'), props: true },

//contract_itens routes
		{ path: '/contract_itens', name: 'contract_itenslist', component: () => import('pages/contract_itens/list.vue'), props: true },
		{ path: '/contract_itens/index/:fieldName?/:fieldValue?', component: () => import('pages/contract_itens/list.vue'), props: true },

//contracts routes
		{ path: '/contracts', name: 'contractslist', component: () => import('pages/contracts/list.vue'), props: true },
		{ path: '/contracts/index/:fieldName?/:fieldValue?', component: () => import('pages/contracts/list.vue'), props: true },

//curr_dtimes routes

//curr_wtimes routes

//descriptions routes

//docs_car_count routes

//docs_client_count routes

//docs_count routes

//docs_driver_count routes

//docs_pending routes

//documents routes

//driver_balance routes

//driver_calendar routes
		{ path: '/driver_calendar', name: 'driver_calendarlist', component: () => import('pages/driver_calendar/list.vue'), props: true },
		{ path: '/driver_calendar/index/:fieldName?/:fieldValue?', component: () => import('pages/driver_calendar/list.vue'), props: true },

//driver_status routes

//driver_times routes

//drivercar routes
		{ path: '/drivercar', name: 'drivercarlist', component: () => import('pages/drivercar/list.vue'), props: true },
		{ path: '/drivercar/index/:fieldName?/:fieldValue?', component: () => import('pages/drivercar/list.vue'), props: true },
		{ path: '/drivercar/view/:id', name: 'drivercarview', component: () => import('pages/drivercar/view.vue'), props: true },
		{ path: '/drivercar/add', name: 'drivercaradd', component: () => import('pages/drivercar/add.vue'), props: true },
		{ path: '/drivercar/drivers', name: 'drivercardrivers', component: () => import('pages/drivercar/drivers.vue'), props: true },
		{ path: '/drivercar/setdriver', name: 'drivercarsetdriver', component: () => import('pages/drivercar/setdriver.vue'), props: true },
		{ path: '/drivercar/setcar', name: 'drivercarsetcar', component: () => import('pages/drivercar/setcar.vue'), props: true },

//drivers routes
		{ path: '/drivers', name: 'driverslist', component: () => import('pages/drivers/list.vue'), props: true },
		{ path: '/drivers/index/:fieldName?/:fieldValue?', component: () => import('pages/drivers/list.vue'), props: true },
		{ path: '/drivers/view/:id', name: 'driversview', component: () => import('pages/drivers/view.vue'), props: true },
		{ path: '/drivers/add', name: 'driversadd', component: () => import('pages/drivers/add.vue'), props: true },
		{ path: '/drivers/editmanager/:id', name: 'driverseditmanager', component: () => import('pages/drivers/editmanager.vue'), props: true },
		{ path: '/drivers/listaddress', name: 'driverslistaddress', component: () => import('pages/drivers/listaddress.vue'), props: true },

//driverssource routes

//fleets routes
		{ path: '/fleets', name: 'fleetslist', component: () => import('pages/fleets/list.vue'), props: true },
		{ path: '/fleets/index/:fieldName?/:fieldValue?', component: () => import('pages/fleets/list.vue'), props: true },
		{ path: '/fleets/view/:id', name: 'fleetsview', component: () => import('pages/fleets/view.vue'), props: true },
		{ path: '/fleets/add', name: 'fleetsadd', component: () => import('pages/fleets/add.vue'), props: true },
		{ path: '/fleets/edit/:id', name: 'fleetsedit', component: () => import('pages/fleets/edit.vue'), props: true },

//freguesias routes

//geolocations routes
		{ path: '/geolocations', name: 'geolocationslist', component: () => import('pages/geolocations/list.vue'), props: true },
		{ path: '/geolocations/index/:fieldName?/:fieldValue?', component: () => import('pages/geolocations/list.vue'), props: true },

//itens routes

//lead_book routes

//ledger routes

//lists routes
		{ path: '/lists', name: 'listslist', component: () => import('pages/lists/list.vue'), props: true },
		{ path: '/lists/index/:fieldName?/:fieldValue?', component: () => import('pages/lists/list.vue'), props: true },

//movements routes

//perm_driver routes

//permi_admin routes

//permi_driver routes

//permi_driver2 routes

//permi_fleet routes

//permi_sales routes

//products routes
		{ path: '/products', name: 'productslist', component: () => import('pages/products/list.vue'), props: true },
		{ path: '/products/index/:fieldName?/:fieldValue?', component: () => import('pages/products/list.vue'), props: true },

//regulatory routes

//reports routes
		{ path: '/reports', name: 'reportslist', component: () => import('pages/reports/list.vue'), props: true },
		{ path: '/reports/index/:fieldName?/:fieldValue?', component: () => import('pages/reports/list.vue'), props: true },
		{ path: '/reports/view/:id', name: 'reportsview', component: () => import('pages/reports/view.vue'), props: true },

//reports_log routes
		{ path: '/reports_log', name: 'reports_loglist', component: () => import('pages/reports_log/list.vue'), props: true },
		{ path: '/reports_log/index/:fieldName?/:fieldValue?', component: () => import('pages/reports_log/list.vue'), props: true },
		{ path: '/reports_log/view/:id', name: 'reports_logview', component: () => import('pages/reports_log/view.vue'), props: true },
		{ path: '/reports_log/add', name: 'reports_logadd', component: () => import('pages/reports_log/add.vue'), props: true },
		{ path: '/reports_log/edit/:id', name: 'reports_logedit', component: () => import('pages/reports_log/edit.vue'), props: true },

//requests routes
		{ path: '/requests', name: 'requestslist', component: () => import('pages/requests/list.vue'), props: true },
		{ path: '/requests/index/:fieldName?/:fieldValue?', component: () => import('pages/requests/list.vue'), props: true },
		{ path: '/requests/add', name: 'requestsadd', component: () => import('pages/requests/add.vue'), props: true },

//roles routes
		{ path: '/roles', name: 'roleslist', component: () => import('pages/roles/list.vue'), props: true },
		{ path: '/roles/index/:fieldName?/:fieldValue?', component: () => import('pages/roles/list.vue'), props: true },

//running routes

//running_by_car routes

//sources routes

//start_end routes
		{ path: '/start_end', name: 'start_endlist', component: () => import('pages/start_end/list.vue'), props: true },
		{ path: '/start_end/index/:fieldName?/:fieldValue?', component: () => import('pages/start_end/list.vue'), props: true },

//status_times routes

//total_hours_day routes
		{ path: '/total_hours_day', name: 'total_hours_daylist', component: () => import('pages/total_hours_day/list.vue'), props: true },
		{ path: '/total_hours_day/index/:fieldName?/:fieldValue?', component: () => import('pages/total_hours_day/list.vue'), props: true },

//total_hours_week routes

//userdriver routes

//users routes
		{ path: '/users', name: 'userslist', component: () => import('pages/users/list.vue'), props: true },
		{ path: '/users/index/:fieldName?/:fieldValue?', component: () => import('pages/users/list.vue'), props: true },
		{ path: '/account/edit', name: 'usersaccountedit', component: () => import('pages/account/accountedit.vue'), props: true },
		{ path: '/account', name: 'usersaccountview', component: () => import('pages/account/accountview.vue'), props: true },

//weekbalance routes

//afterinsertpage routes

//beforeinsertpage routes

//closepage routes

//contractactivate routes

//contractadd routes

//contractdeactivate routes

//dig routes

//drivercalendar routes

//getreportatividades routes

//getshift routes

//gettimedriving routes

//gettimes routes

//gettimesnow routes

//insertstatus routes

//moveuser routes

//mydebug routes

//pivot routes

//readstatus routes

//readtimes routes

//signilizeerror routes

//totalvendas routes

//vdsrequests routes
		{ path: '/vdsrequests', name: 'vdsrequestslist', component: () => import('pages/vdsrequests/list.vue'), props: true },
		{ path: '/vdsrequests/index/:fieldName?/:fieldValue?', component: () => import('pages/vdsrequests/list.vue'), props: true },

//permivendas2 routes

//permivendas3 routes

//passwordresets routes

//oauthclients routes

//oauthaccesstokens routes

//oauthrefreshtokens routes

//oauthauthcodes routes

//failedjobs routes

//oauthpersonalaccessclients routes

//migrations routes

//rolesadmin routes

//permiadmin2 routes

		{ path: '/myplan', name: 'myplan', component: () => import('pages/custom/myplan.vue'), props: true },
		{ path: '/changepassword', name: 'changepassword', component: () => import('pages/custom/changepassword.vue'), props: true },
		{ path: '/logout', name: 'logout', component: () => import('pages/custom/logout.vue'), props: true },
		{ path: '/mycompany', name: 'mycompany', component: () => import('pages/custom/mycompany.vue'), props: true },


//Password reset routes
		{ path: '/index/forgotpassword', name: 'forgotpassword', component: () => import('pages/index/forgotpassword.vue') },
		{ path: '/index/resetpassword', name: 'resetpassword', component: () => import('pages/index/resetpassword.vue') },
		{ path: '/index/resetpassword_completed', name: 'resetpassword_completed', component: () => import('pages/index/resetpassword_completed.vue') },



		//Error pages
		{ path: '/error/rejected', name: 'rejected', component: () => import('pages/errors/rejected.vue') },
		{ path:  '/error/forbidden', name: 'forbidden',  component: () => import('pages/errors/forbidden.vue') },
		{ path: '/error/notfound',  name: 'notfound', component: () => import('pages/errors/pagenotfound.vue') }
	],

	},
	{ path: '/:catchAll(.*)*', component: () => import('pages/errors/pagenotfound.vue') }
];

export default route(async function () {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : (process.env.VUE_ROUTER_MODE == 'history' ? createWebHistory : createWebHashHistory)

	const mainRoute = routes.find(x => x.name = "main");

	const auth = useAuth();


	const { user, userRole } = await auth.getUserData();
	if(user){
		const roleName = userRole.toLowerCase();

		let rolePage;
		switch(roleName){
			case "manager":
				rolePage = "manager";
				break;
			default:
				rolePage = "home";
		}

		const homeRoute = {
			path: '/', alias: '/home', name: 'home', component: () => import(`pages/home/${rolePage}.vue`)
		}

		mainRoute.children.push(homeRoute);
	}
	else{
		const indexRoute = { path: '/',  alias: '/home', name: 'index', component: () => import('pages/index/index.vue') }
		mainRoute.children.push(indexRoute);
	}

	const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,
    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE)
  })
  return Router
})

